import { render, staticRenderFns } from "./linkModule.vue?vue&type=template&id=d087fc42&scoped=true"
import script from "./linkModule.vue?vue&type=script&lang=js"
export * from "./linkModule.vue?vue&type=script&lang=js"
import style0 from "./linkModule.vue?vue&type=style&index=0&id=d087fc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d087fc42",
  null
  
)

export default component.exports